import { useCallback } from 'react';
import { useApiPost } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
export function useCreateSiteDialog(siteId) {
    const { data, isLoading, error, post } = useApiPost(`sites/${siteId}/dialogs`);
    const { plugins } = useSiteContext();
    const createSiteDialog = useCallback((name, type) => {
        const plugin = plugins.find(p => p.type === type);
        const componentDto = {
            name,
            type: plugin === null || plugin === void 0 ? void 0 : plugin.type
        };
        // create child components if slots are defined
        if (plugin === null || plugin === void 0 ? void 0 : plugin.slots) {
            componentDto.children = plugin.slots;
        }
        post(componentDto);
    }, [plugins, post]);
    return {
        createdSiteDialog: data,
        creatingSiteDialog: isLoading,
        createSiteDialogError: error,
        createSiteDialog
    };
}
//# sourceMappingURL=useCreateSiteDialog.js.map